import React, { useState } from 'react'
import { Accordion, Button } from 'react-bootstrap'

import './styles.css'

const Faq = ({accordion}) => {

    return (
        <div className="fqa-container">
            <div className="fqa-content">
                <h1 className="fqa-title">Data Service - Data Engineer</h1>
                <Accordion defaultActiveKey="0" className="fqa-content fqa-content-accordion">
                    {accordion.map((item, index) => (
                        <Accordion.Item eventKey={index}>
                            <Accordion.Header>{item.title}</Accordion.Header>
                            <Accordion.Body>{item.body}</Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </div>
    );
}

export default Faq;
